"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyWithNameDelivery = exports.dummyWithName = exports.dummyWithAddress = exports.tripLocationFromGeocodeResultAndPlace = exports.tripLocationFromPlace = exports.tripLocationFromGeocodeResult = exports.tripLocationsDeserialize = exports.tripLocationDeserialize = void 0;
const PlaceController_1 = __importDefault(require("../controllers/google-maps/PlaceController"));
const MomentHelper_1 = __importDefault(require("../helpers/MomentHelper"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const CoordinatesArray_1 = require("./CoordinatesArray");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const DatabaseTimestamp_1 = require("./firebase/DatabaseTimestamp");
const GeocodeResult_1 = require("./google-maps/GeocodeResult");
const Location_1 = require("./Location");
const TripContent_1 = __importDefault(require("./TripContent"));
const UserType_1 = require("./UserType");
function tripLocationDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return Object.assign(Object.assign({}, (0, Location_1.locationDeserialize)(value)), { contactUserType: (0, unwrap_1.default)(object.contactUserType, UserType_1.userTypeDeserialize), instructions: (0, unwrap_1.default)(object.instructions, deserializeString_1.deserializeString), passengerCount: (0, unwrap_1.default)(object.passengerCount, deserializePassengerCount), contents: (0, unwrap_1.default)(object.contents, (0, deserializeArray_1.default)(TripContent_1.default.deserialize)), waitTimeS: (0, unwrap_1.default)(object.waitTimeS, deserializeNumber_1.deserializeNumber), requestedTimestampMs: (0, unwrap_1.default)(object.requestedTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize), scheduledTimestampMs: (0, unwrap_1.default)(object.scheduledTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize), estimatedArrivalTimestampMs: (0, unwrap_1.default)(object.estimatedArrivalTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize), arrivalTimestampMs: (0, unwrap_1.default)(object.arrivalTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize), completionTimestampMs: (0, unwrap_1.default)(object.completionTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize), timeZoneIdentifier: (0, unwrap_1.default)(object.timeZoneIdentifier, deserializeString_1.deserializeString), zoneId: (0, unwrap_1.default)(object.zoneId, deserializeString_1.deserializeString), zoneName: (0, unwrap_1.default)(object.zoneName, deserializeString_1.deserializeString), destinationName: (0, unwrap_1.default)(object.destinationName, deserializeString_1.deserializeString) });
}
exports.tripLocationDeserialize = tripLocationDeserialize;
const deserializePassengerCount = (value) => (0, deserializeNumber_1.deserializeNumber)(value, 0, 1000, true);
exports.tripLocationsDeserialize = (0, deserializeArray_1.default)(tripLocationDeserialize);
async function tripLocationFromGeocodeResult(result, forcedCoordinates, options) {
    const response = await PlaceController_1.default.details(result.place_id, ['name', 'utc_offset'], options);
    const { name, utc_offset } = response.result;
    return {
        coordinates: forcedCoordinates !== null && forcedCoordinates !== void 0 ? forcedCoordinates : (0, CoordinatesArray_1.coordinatesArrayFromLatLngLiteral)(result.geometry.location),
        address: result.formatted_address,
        googlePlaceId: result.place_id,
        name: name && result.formatted_address.startsWith(name) ? undefined : name,
        state: (0, GeocodeResult_1.geocodeResultState)(result.address_components),
        timeZoneIdentifier: (0, unwrap_1.default)(utc_offset, offset => MomentHelper_1.default.timezoneForAddressComponents(result.address_components, offset)),
    };
}
exports.tripLocationFromGeocodeResult = tripLocationFromGeocodeResult;
function tripLocationFromPlace(place, forcedCoordinates) {
    const tripLocation = (0, Location_1.locationFromPlace)(place);
    if (forcedCoordinates) {
        tripLocation.coordinates = forcedCoordinates;
    }
    tripLocation.timeZoneIdentifier = (0, unwrap_1.default)(place.utc_offset, offset => (0, unwrap_1.default)(place.address_components, components => MomentHelper_1.default.timezoneForAddressComponents(components, offset)));
    return tripLocation;
}
exports.tripLocationFromPlace = tripLocationFromPlace;
/**
 *
 * @param place Place details request must include the following fields: name, utc_offset
 * @param geocodingResult
 * @returns
 */
async function tripLocationFromGeocodeResultAndPlace(place, geocodingResult) {
    return {
        coordinates: (0, CoordinatesArray_1.coordinatesArrayFromLatLngLiteral)(geocodingResult.geometry.location),
        address: geocodingResult.formatted_address,
        googlePlaceId: geocodingResult.place_id,
        name: (0, unwrap_1.default)(place.name, name => (geocodingResult.formatted_address.startsWith(name) ? undefined : name)),
        state: (0, GeocodeResult_1.geocodeResultState)(geocodingResult.address_components),
        timeZoneIdentifier: (0, unwrap_1.default)(place.utc_offset, offset => MomentHelper_1.default.timezoneForAddressComponents(geocodingResult.address_components, offset)),
    };
}
exports.tripLocationFromGeocodeResultAndPlace = tripLocationFromGeocodeResultAndPlace;
exports.dummyWithAddress = {
    coordinates: [35.134342, -80.87138569999999],
    address: '7127 Thornrose Dr, Charlotte, NC 28210, USA',
};
exports.dummyWithName = {
    coordinates: [35.134342, -80.87138569999999],
    address: '333 West Trade St, Charlotte, NC 28202 USA',
    name: 'IBG Software',
};
exports.dummyWithNameDelivery = {
    coordinates: [35.134342, -80.87138569999999],
    address: '123 A street street, Charlotte, NC, 28202',
    name: "Willy's Mexicana Grill",
};
